import React, { useEffect, useState } from 'react';
import { Box, SwipeableDrawer, useMediaQuery } from '@mui/material';
import eventBus, { eventBusValues } from '../../../eventBus';
import ConversationContainer from '../ContainerV2';
import ConversationLeftMenu from '../leftMenuV2';
import { useAccount } from '../../../contexts/Account';
import {
  getCompanyContacts,
} from '../../../services/company_services';

const ConversationDrawer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [conversationId, setConversationId] = useState();
  const [ceo, setCeo] = useState({});
  const isSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const isXS = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const [showLeftMenu, setShowLeftMenu] = useState(false);
  const { conversations } = useAccount();

  useEffect(() => {
    eventBus.on(eventBusValues.triggerConversationDrawerV2, (data) => {
      if (data.close) {
        setIsOpen(false);
      } else {
        setIsOpen(true);
      }
      if (data.conversationId) {
        setConversationId(data.conversationId);
      } else {
        setConversationId(
          conversations[0] ? conversations[0].conversationId : null
        );
      }
    });

    return () => {
      eventBus.remove(eventBusValues.triggerConversationDrawerV2);
    };
  }, []);

  useEffect(() => {
    // const acId = '04dd3d51-e97a-47ea-b613-38b0a594cf1b';
    const acId = '2e8c8dd5-c1b6-44af-967d-376e5d092832';
    getCompanyContacts({
      companyId: acId,
    })
      .then((response) => {
        if (response.data && response.data.getCompanyContacts) {
          const sortedContacts = response.data.getCompanyContacts.sort(
            (a, b) => {
              return b.isBoardOwner - a.isBoardOwner;
            }
          );
          setCeo({
            id: sortedContacts[0].id,
            image: sortedContacts[0].contactLogoLocation,
            name: sortedContacts[0].displayName,
            position: sortedContacts[0].title,
            companyId: acId,
          });
        }
      })
      .catch(() => {});
  }, []);

  return (
    <div style={{ width: '100%' }}>
      <SwipeableDrawer
        disableSwipeToOpen
        anchor="right"
        open={isOpen}
        onOpen={() => {}}
        onClose={() => setIsOpen(false)}
      >
        {conversations && conversations.length > 0 && (
          <>
            <Box
              sx={{
                display: 'flex',
                width: isSM ? '100vw' : '1000px',
              }}
            >
              <Box sx={{ flex: 1 }}>
                <ConversationContainer
                  showLeftMenu={showLeftMenu}
                  setShowLeftMenu={setShowLeftMenu}
                  propConversationId={conversationId}
                  setPropConversationId={setConversationId}
                  ceo={ceo}
                />
              </Box>
              <Box sx={{ width: isXS ? 'auto' : '300px' }}>
                <ConversationLeftMenu
                  setConversationId={setConversationId}
                  conversationId={conversationId}
                  show={showLeftMenu}
                  setShow={setShowLeftMenu}
                  ceo={ceo}
                />
              </Box>
            </Box>
          </>
        )}
      </SwipeableDrawer>
    </div>
  );
};

export default ConversationDrawer;
